import { IState } from '..';
import { EDealType, EOfferType } from '../../repositories/hidden-objects/entities/schemas/HideOfferRequestSchema';
import { IHideOfferWebsiteRequest } from '../../repositories/hidden-objects/v1/hide-offer-website';

export function selectRequestParameters(state: IState): IHideOfferWebsiteRequest {
  const { dealType, id, offerType, publishedUserId, geo } = state.offerData.offer;
  let houseId;
  /* istanbul ignore next */
  if (geo) {
    const house = geo.address.find(a => a.type === 'house');
    houseId = house && house.id;
  }

  return {
    offerId: id,
    dealType: dealType as EDealType,
    offerType: offerType as EOfferType,
    publishedUserId: publishedUserId || 0,
    houseId,
  };
}
